module.exports = __webpack_public_path__ + "media/site_templates/www.rangehood-installation.com.au/images/about_us-1ca1ccf42e9e5dce153cb5047d70a4e9.jpg";